import * as components from './components'
export default [
  {
    path: '/employer/:uuid/home',
    component: components.EmployerHome,
    name: 'employerHome',
    props: true
  },
  {
    path: '/employer/:uuid/edit',
    component: components.EmployerEdit,
    name: 'employerEdit',
    props: true
  },
  {
    path: '/employer/:uuid/category',
    component: components.EmployerAllCategories,
    name: 'employerAllCategories',
    props: true
  },
  {
    path: '/employer/:uuid/category/:category',
    component: components.EmployerCategory,
    name: 'employerCategory',
    props: true
  },
  {
    path: '/employer/:uuid/report',
    component: components.EmployerReport,
    name: 'employerReport',
    props: true
  },
  {
    path: '/employer/create',
    component: components.EmployerCreate,
    name: 'employerCreate',
    props: true
  },
  {
    path: '/employer/upload',
    component: components.EmployerUpload,
    name: 'employerUpload',
    props: true
  }
/*  ,
  Using Manage Jobs for this route
  {
    path: '/employer/admin',
    component: components.EmployerAdmin,
    name: 'employerAdmin',
    props: true
  }
*/  
]



// WEBPACK FOOTER //
// ./src/app/employer/routes.js